module.exports = __webpack_public_path__ + "img/icon-nft-eliw.97fed010.svg";